import { render, staticRenderFns } from "./BrowserDisplayOverlay.vue?vue&type=template&id=6d66f7f3"
import script from "./BrowserDisplayOverlay.vue?vue&type=script&lang=js"
export * from "./BrowserDisplayOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports